// extracted by mini-css-extract-plugin
export default {"root":"style_root__ezuFb","dealt":"style_dealt__fGoq7","abilityActive":"style_abilityActive__DRDcF"};